import React from "react";
import { Group, Text, Box, Stack } from "@mantine/core";
import styles from "./CustomStepper.module.css";

interface Step {
  label: string;
}

interface CustomStepperProps {
  active: number;
  steps: Step[];
}

export default function CustomStepper({ active, steps }: CustomStepperProps) {
  return (
    <Box className={styles.stepperContainer}>
      <Group gap="md" justify="center" className={styles.stepperGroup}>
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isActive = index === active;
          const isCompleted = index < active;

          return (
            <React.Fragment key={index}>
              <Stack gap="xs" align="center" className={styles.stepWrapper}>
                <Box
                  className={`${styles.stepIndicator} ${
                    isActive ? styles.stepIndicatorActive : ""
                  } ${isCompleted ? styles.stepIndicatorCompleted : ""}`}
                >
                  <Text size="sm" fw={600} c="#ffffff">
                    {stepNumber}
                  </Text>
                </Box>
                <Text
                  size="sm"
                  fw={isActive || isCompleted ? 600 : 400}
                  ta="center"
                  className={`${styles.stepLabel} ${
                    isActive ? styles.stepLabelActive : ""
                  } ${isCompleted ? styles.stepLabelCompleted : ""}`}
                >
                  {step.label}
                </Text>
              </Stack>
              {index < steps.length - 1 && (
                <Box className={styles.connector} aria-hidden="true" />
              )}
            </React.Fragment>
          );
        })}
      </Group>
    </Box>
  );
}
